import React, { useEffect, useState } from "react";
import { getCapacitorVersion } from "@utils/specific/capacitor/helpers";
import { useTranslation } from "react-i18next";

export function CapacitorBundleVersion() {
	const [version, setVersion] = useState<string | null>(null);
	const { t } = useTranslation();

	useEffect(() => {
		async function getVersion() {
			const version = await getCapacitorVersion();
			setVersion(version);
		}
		getVersion();
	}, []);

	if (!version) {
		return null;
	}

	return (
		<div>{t("CAPACITOR_UPDATE.CURRENT_VERSION", { version: version })}</div>
	);
}
